import React from 'react';
import classNames from 'classnames';

export default function BaseCheckBoxButton(props) {
  const {
          action,
          label,
          selected,
        } = props;

  const handleClick = (event, selected) => {
    event.preventDefault();
    event.stopPropagation();

    action(selected);
  };

  return (
    <span
      className={classNames({ 'checked': selected === 1 })}
      onClick={(event) => handleClick(event, selected === 0 ? 1 : null)}
    >
        {label}
      </span>
  );
}